import { State, initialState } from './user.state';
import { userActionTypes, Actions } from './user.actions';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function UserReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case userActionTypes.UserProfile_Load_SUCCESS: {
      return Object.assign({}, state, { userProfile: action.payload });
    }

    case userActionTypes.UpdateProfile_SUCCESS: {

      // Preserve values that are not part of the update profile response
      action.payload.userId = state.userProfile.userId;
      action.payload.workspaceUserId = state.userProfile.workspaceUserId;
      action.payload.joinedOn = state.userProfile.joinedOn;
      action.payload.imageUrl = state.userProfile.imageUrl;
      action.payload.recentPropertyName = state.userProfile.recentPropertyName;

      return Object.assign({}, state, { userProfile: action.payload });
    }
    /*
        case Auth.LOGOUT: {
          return Object.assign({}, initialState);
        }
        */
    default: {
      return state;
    }
  }
}
